import { Grid, Box, Image, Text } from '@everlywell/ui-kit';
import React from 'react';
import { IBenefitsSectionProps, ICardProps } from 'utils/types';

const Card: React.FC<ICardProps> = ({ image, description }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    textAlign="center"
    maxWidth="450px"
    margin="0 auto"
    padding="16px"
  >
    <Image src={image} alt="Card Image" maxWidth="350px" marginBottom="16px" />
    <Text color="#545454" maxWidth="300px" fontSize="lg">
      {description}
    </Text>
  </Box>
);

export const BenefitsSection: React.FC<IBenefitsSectionProps> = ({
  features,
}) => (
  <Box as="section"width="100%">
    <Box padding="32px 16px" maxWidth="1440px" mx="auto" width="100%">
      <Grid
        data-testid="mock-grid"
        gridTemplateColumns={{
          base: '1fr',
          md: 'repeat(3, 1fr)',
        }}
        alignItems="center"
        justifyContent="center"
        gap="32px"
      >
        {features.map((feature, index) => (
          <div key={index} data-testid="benefit-card" className="benefit-card">
            <Card
              image={feature.featureImage.url}
              description={feature.description}
            />
          </div>
        ))}
      </Grid>
    </Box>
  </Box>
);
